import React from "react"

import { UpdateFollowUpConfigurationInput } from "shared/types/__generated__/graphql"

import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

import { GroupEntryInput } from "../model/useFollowUpConfigurationAdminPageViewModel"
import { FollowUpConfigurationGroupData } from "../types/FollowUpConfigurationGroupData"
import { FollowUpConfigurationGroupConnector } from "./FollowUpConfigurationGroupConnector"

interface FollowUpConfigurationGroupListProps {
  groups: FollowUpConfigurationGroupData[]
  productOptions: ProductSelectOption[]
  onUpdate: (id: string, input: UpdateFollowUpConfigurationInput) => void
  onDelete: (id: string) => Promise<void>
  onAddToGroup: (
    sourceProductName: string,
    data: GroupEntryInput
  ) => Promise<void>
  isCreating?: boolean
  isUpdating?: boolean
  isDeleting?: boolean
  isReorderDisabled?: boolean
}

export const FollowUpConfigurationGroupList = React.memo(
  ({
    groups,
    productOptions,
    onUpdate,
    onDelete,
    onAddToGroup,
    isCreating,
    isUpdating,
    isDeleting,
    isReorderDisabled
  }: FollowUpConfigurationGroupListProps) => {
    return (
      <div className="follow-up-config-admin-page__groups">
        {groups.map(group => (
          <FollowUpConfigurationGroupConnector
            key={group.sourceProduct.id}
            group={group}
            productOptions={productOptions}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onAddToGroup={onAddToGroup}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDeleting={isDeleting}
            isReorderDisabled={isReorderDisabled}
          />
        ))}
      </div>
    )
  }
)

FollowUpConfigurationGroupList.displayName = "FollowUpConfigurationGroupList"
